import { useSelector } from "react-redux";

import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline, StyledEngineProvider } from "@mui/material";
import Routes from "routes";
import themes from "themes";
import Locales from "ui-component/Locales";
import NavigationScroll from "layout/NavigationScroll";
import Snackbar from "ui-component/extended/Snackbar";
import { JWTProvider } from "contexts/JWTContext";
import "./App.css";
import { SnackbarProvider } from "notistack";
import { useEffect } from "react";
import * as pkg from "../package.json";
// import { SignalRProvider } from "contexts/SignalRContext";

const App = () => {
  useEffect(
    () => window.console.log(`Project Medmasraf 🚀 v${pkg.version} - ${process.env.REACT_APP_ENV}`),
    []
  );

  const customization = useSelector((state) => state.customization);

  return (
    <SnackbarProvider autoHideDuration={null}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={themes(customization)}>
          <CssBaseline />
          {/* <SignalRProvider> */}
          <Locales>
            <NavigationScroll>
              <JWTProvider>
                <>
                  <Routes />
                  <Snackbar />
                </>
              </JWTProvider>
            </NavigationScroll>
          </Locales>
          {/* </SignalRProvider> */}
        </ThemeProvider>
      </StyledEngineProvider>
    </SnackbarProvider>
  );
};

export default App;
